import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import {
	type InteracaoFormData,
	interacaoSchema,
} from '../../schemas/interacao-schema'

export function useInteracaoForm() {
	return useForm<InteracaoFormData, Record<string, never>, InteracaoFormData>({
		defaultValues: {
			date: '',
			employeeId: '',
			leaderId: '',
			potential: '',
			classificationId: '',
			subclassificationId: '',
			description: '',
			action: '',
		},
		resolver: zodResolver(interacaoSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
